export default "__VITE_ASSET__$bUGKXO8__"